import store from '@shared/store/index';

import { computed } from "vue";

const notificationsList = computed(() => store.state.Notifications.list);

const avatarList = computed(() => store.state.Notifications.avatarList);

const notificationsCount = computed(() => store.state.Notifications.notificationsCount);

const isReady = computed(() => store.state.Notifications.isReady);

const isListReady = computed(() => store.state.Notifications.isListReady);

const isLoadingNextPage = computed(() => store.state.Notifications.loadingNextPage);

export function useNotificationsState() {
  return {
    avatarList,
    notificationsList,
    notificationsCount,
    isReady,
    isListReady,
    isLoadingNextPage
  };
}